import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Trash } from "iconsax-react";
import Select from "react-select";

function Contact({ contactInfo, setContactInfo, editData, isEdit }) {
  const [states, setStates] = useState([]);
  const [dis, setDis] = useState([]);
  const [city, setCity] = useState([]);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    getState();
  }, []);

  const getState = () => {
    utils
      .callAPI("get", `/state/list`)
      .then((res) => {
        if (Array.isArray(res)) {
          setStates(res);
        } else {
          setStates([]);
        }
      })
      .catch((err) => {
        setStates([]);
      });
  };
  const getDisByState = (stateId, index) => {
    utils
      .callAPI("get", `/district/list?stateId=${stateId}`)
      .then((res) => {
        if (Array.isArray(res)) {
          const updatedContactInfo = [...contactInfo];
          updatedContactInfo[index].districts = res;
          updatedContactInfo[index].district = "";
          updatedContactInfo[index].city = "";
          updatedContactInfo[index].cities = [];
          setContactInfo(updatedContactInfo);
        }
      })
      .catch((err) => {
        // Handle error
      });
  };

  const getCitiesForRow = (districtId, index) => {
    utils
      .callAPI("get", `/city/by-district-list?districtId=${districtId}`)
      .then((res) => {
        if (Array.isArray(res)) {
          const updatedContactInfo = [...contactInfo];
          updatedContactInfo[index].cities = res;
          updatedContactInfo[index].city = "";
          setContactInfo(updatedContactInfo);
        }
      })
      .catch((err) => {
        // Handle error
      });
  };
  useEffect(() => {
    if (isEdit) {
      const formattedContactInfo = editData.map((item) => ({
        id: item.id,
        contactNumber: item.mobileNo,
        gstNumber: item.gstNo,
        addressType: item.addressType,
        address: item.address,
        state: item.state,
        district: item.district,
        city: item.city,
        pincode: item.pincode,
        districts: [],
        cities: [],
      }));

      setContactInfo(formattedContactInfo);

      formattedContactInfo.forEach((item, index) => {
        fetchDistrictAndCity(
          item.state,
          item.district,
          index,
          formattedContactInfo
        );
      });
    }
  }, [isEdit]);

  const fetchDistrictAndCity = async (
    state,
    district,
    index,
    currentContactInfo
  ) => {
    try {
      const updatedContactInfo = await getDisByStatee(
        state,
        index,
        currentContactInfo
      );
      await getCitiesForRowe(district, index, updatedContactInfo);
      // Set the updated contact info after both API calls
      setContactInfo(updatedContactInfo);
    } catch (error) {
      console.error(`Error fetching data for index ${index}:`, error);
    }
  };

  const getDisByStatee = (stateId, index, currentContactInfo) => {
    return utils
      .callAPI("get", `/district/list?stateId=${stateId}`)
      .then((res) => {
        if (Array.isArray(res)) {
          const updatedContactInfo = [...currentContactInfo];
          updatedContactInfo[index].districts = res;
          updatedContactInfo[index].district =
            currentContactInfo[index]?.district || "";
          return updatedContactInfo; // Return updated contact info
        }
        return currentContactInfo; // Return original if no districts
      })
      .catch((err) => {
        console.error("Error fetching districts:", err);
        return currentContactInfo; // Return original in case of error
      });
  };

  const getCitiesForRowe = (districtId, index, currentContactInfo) => {
    return utils
      .callAPI("get", `/city/by-district-list?districtId=${districtId}`)
      .then((res) => {
        if (Array.isArray(res)) {
          const updatedContactInfo = [...currentContactInfo];
          updatedContactInfo[index].cities = res;
          updatedContactInfo[index].city =
            currentContactInfo[index]?.city || "";
          return updatedContactInfo; // Return updated contact info
        }
        return currentContactInfo; // Return original if no cities
      })
      .catch((err) => {
        console.error("Error fetching cities:", err);
        return currentContactInfo; // Return original in case of error
      });
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedContactInfo = [...contactInfo];
    const updatedErrors = [...errors];

    if (name === "pincode") {
      if (/^\d*$/.test(value)) {
        updatedContactInfo[index][name] = value;
        updatedErrors[index] = { ...updatedErrors[index], contactNumber: "" };
      } else {
        return;
      }
    } else if (name === "contactNumber") {
      if (/^\d*$/.test(value)) {
        if (value.length <= 10) {
          updatedContactInfo[index][name] = value;
          updatedErrors[index] = { ...updatedErrors[index], contactNumber: "" };
        } else {
          updatedErrors[index] = {
            ...updatedErrors[index],
            contactNumber: "Contact number cannot exceed 10 digits",
          };
          return;
        }
      } else {
        updatedErrors[index] = {
          ...updatedErrors[index],
          contactNumber: "Invalid contact number",
        };
        return;
      }
    } else if (name === "gstNumber") {
      updatedContactInfo[index][name] = value.toUpperCase();
    } else {
      updatedContactInfo[index][name] = value;
    }

    setContactInfo(updatedContactInfo);
    setErrors(updatedErrors);

    if (name === "state") {
      getDisByState(value, index);
    }
    if (name === "district") {
      getCitiesForRow(value, index);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(contactInfo);
  };

  const handleDelete = (index) => {
    const updatedContactInfo = contactInfo.filter((_, i) => i !== index);
    setContactInfo(updatedContactInfo);
  };

  return (
    <>
      {contactInfo.map((info, index) => (
        <div key={index} className="card p-2 contact-info mb-3">
          {index > 0 && (
            <div className="delete-btn-container">
              <RB.Button
                className="btn-flat position-absolute top-0 end-0 m-2"
                title="Delete"
                onClick={() => handleDelete(index)}
              >
                <Trash />
              </RB.Button>
            </div>
          )}
          <RB.Row className="mt-3">
            <RB.Col md={4} className="mt-2">
              <RB.FloatingLabel
                controlId={`contactNumber-${index}`}
                label="GST Number (Varify)"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  type="text"
                  name="gstNumber"
                  value={info.gstNumber}
                  onChange={(e) => handleInputChange(e, index)}
                  placeholder="Enter GST Number"
                  required
                />
              </RB.FloatingLabel>
            </RB.Col>

            <RB.Col md={4} className="mt-2">
              <RB.FloatingLabel
                controlId={`contactNumber-${index}`}
                label="Contact Number"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  type="text"
                  name="contactNumber"
                  value={info.contactNumber}
                  onChange={(e) => handleInputChange(e, index)}
                  placeholder="Enter Contact Number"
                  isInvalid={errors[index]?.contactNumber}
                  required
                />
                <RB.Form.Control.Feedback type="invalid">
                  {errors[index]?.contactNumber}
                </RB.Form.Control.Feedback>
              </RB.FloatingLabel>
            </RB.Col>

            <RB.Col md={4} className="mt-2">
              <RB.FloatingLabel
                controlId={`addressType-${index}`}
                label="Address Type"
                className="floating-label-fancy"
              >
                <RB.Form.Select
                  name="addressType"
                  value={info.addressType}
                  onChange={(e) => handleInputChange(e, index)}
                  aria-label="Select Address Type"
                >
                  <option value="">Select Address Type</option>
                  <option value="Home">Home</option>
                  <option value="Office">Office</option>
                  <option value="Other">Other</option>
                </RB.Form.Select>
              </RB.FloatingLabel>
            </RB.Col>

            <RB.Col md={4} className="mt-2">
              <RB.FloatingLabel
                controlId={`address-${index}`}
                label="Address"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  type="text"
                  name="address"
                  value={info.address}
                  onChange={(e) => handleInputChange(e, index)}
                  placeholder="Enter Address"
                  required
                />
              </RB.FloatingLabel>
            </RB.Col>
            <RB.Col md={4} className="mt-4">
              <Select
                name="state"
                placeholder="Select State"
                options={states.map((state) => ({
                  label: state.state_name,
                  value: state.state_code,
                }))}
                value={
                  states
                    .map((state) => ({
                      label: state.state_name,
                      value: state.state_code,
                    }))
                    .find((opt) => opt.value === info.state) || null
                }
                onChange={(selected) => {
                  const syntheticEvent = {
                    target: {
                      name: "state",
                      value: selected ? selected.value : "",
                    },
                  };
                  handleInputChange(syntheticEvent, index);
                }}
                className="bom-productName-select"
                isClearable
              />
            </RB.Col>
            <RB.Col md={4} className="mt-4">
              <Select
                name="district"
                placeholder="Select District"
                options={info.districts?.map((dist) => ({
                  label: dist.district_name,
                  value: dist.district_code,
                }))}
                className="bom-productName-select"
                value={
                  info.districts
                    ?.map((dist) => ({
                      label: dist.district_name,
                      value: dist.district_code,
                    }))
                    .find((opt) => opt.value === info.district) || null
                }
                onChange={(selected) => {
                  const syntheticEvent = {
                    target: {
                      name: "district",
                      value: selected ? selected.value : "",
                    },
                  };
                  handleInputChange(syntheticEvent, index);
                }}
                isClearable
              />
            </RB.Col>
            <RB.Col md={4} className="mt-4">
              <Select
                name="city"
                placeholder="Select City"
                options={info.cities?.map((city) => ({
                  label: city.city_name,
                  value: city.city_code,
                }))}
                value={
                  info.cities
                    ?.map((city) => ({
                      label: city.city_name,
                      value: city.city_code,
                    }))
                    .find((opt) => opt.value === info.city) || null
                }
                className="bom-productName-select"
                onChange={(selected) => {
                  const syntheticEvent = {
                    target: {
                      name: "city",
                      value: selected ? selected.value : "",
                    },
                  };
                  handleInputChange(syntheticEvent, index);
                }}
                isClearable
              />
            </RB.Col>
            <RB.Col md={4} className="mt-2">
              <RB.FloatingLabel
                controlId={`pincode-${index}`}
                label="Pincode"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  type="text"
                  name="pincode"
                  value={info.pincode}
                  onChange={(e) => handleInputChange(e, index)}
                  placeholder="Enter Pincode"
                />
              </RB.FloatingLabel>
            </RB.Col>
          </RB.Row>
        </div>
      ))}
    </>
  );
}

export default Contact;
